import { useCallback } from "react";

import useAxios from "axios-hooks";

import { userNotification } from "utils/helperFunctions";
import { createQuickBookOrder, cancelQuickBookOrder } from "utils/apiConfig";

export const useQuickBookOrder = () => {
  // ==============================|| API ||============================== //

  // API call to create/cancel quickBook order
  const [{ data, loading, error }, quickBookOrderAPICall] = useAxios(
    {},
    { manual: true }
  );

  // ==============================|| handler functions ||============================== //

  // function to call quickBook create/cancel order API
  const quickBookOrderAPI = useCallback(
    async (id: string, createOrderFlag: boolean): Promise<string> => {
      try {
        // API call to create/cancel order in quickBook inventory
        const { data } = await quickBookOrderAPICall(
          createOrderFlag ? createQuickBookOrder(id) : cancelQuickBookOrder(id)
        );

        // verify API response
        if (data?.status === 200 && data?.data?.invoice_id) {
          return data?.data?.invoice_id;
        }

        // function to set message to notify user
        userNotification(
          `Failed to ${createOrderFlag ? "create" : "cancel"} invoice!`
        );

        return "";
      } catch (error) {
        // function to set message to notify user
        userNotification(
          `Failed to ${createOrderFlag ? "create" : "cancel"} invoice!`
        );

        return "";
      }
    },
    [quickBookOrderAPICall]
  );

  return {
    quickBookOrderData: data,
    quickBookOrderLoading: loading,
    quickBookOrderError: error,
    quickBookOrderAPICall: quickBookOrderAPI,
  };
};
